<template>
  <div class="main">
    <PageHeader :title="isTablet?'':'感想文'" class="list whitespace-nowrap">
      <template #title-header-content>
        <div class="flex justify-end flex-1 items-center">
          <!-- 新規作成 -->
          <div v-if="tabNo==2&&(review.id || list.length)">
            <PrimaryButton text="新規作成" size="normal hover:bg-pink-400 mr-5" class="new" @click="setNewReview()"/>
          </div>
          <!-- 説明 -->
          <div v-if="!isMobileDevice&&tabNo==3" class="mr-auto font-bold text-xs">
            <div v-if="!boss&&!auth" class="text-white">自分の分のみ表示</div>
            <div v-if="isTablet" class="text-red-50 mt-1">※行タップで詳細確認可能</div>
            <div v-else class="text-red-50 mt-1">※行をクリックで詳細確認可能</div>
          </div>
          <!-- 切替 PC用 -->
          <div v-if="!isMobileDevice" class="bg-white rounded mr-2">
            <div class="flex items-center py-1 rounded mx-5 ">
              <div v-for="t in tabList"
                :key="'tab' + t.id"
                class="w-32 text-center mx-1 cursor-pointer"
                :class="[tabNo == t.id ? 'bg-light-blue-700' : 'hover:bg-gray-400', 'bg-gray-300 rounded-md py-1 text-sm font-medium text-white']"
                @click="changeTab(t.id)"
              >
                {{ t.name }}
              </div>
            </div>
          </div>

          <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{'animate-spin': loading}"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh()"
          />
        </div>
      </template>
      <template #page-header-content>
        <div v-if="tabNo==3&&!isMobileDevice" class="flex justify-end">
          <!-- 期間 -->
          <div class="flex items-stretch mx-2">
            <input type="date" v-model="filter.start" class="text-sm rounded border-gray-300 p-1 min-w-90px" />
            <div class="w-fit text-white text-lg font-bold mx-1 my-auto">～</div>
            <input type="date" v-model="filter.end" class="text-sm rounded border-gray-300 p-1 min-w-90px" />
            <div class="text-xs py-2 px-3 bg-green-100 text-green-800 border border-green-800 rounded cursor-pointer ml-1 font-bold" @click="deletePeriod()">
              期間なし
            </div>
          </div>

          <!-- 部下全員 切り替え -->
          <div v-if="(auth||boss)" class="flex items-center mr-2">
            <div class="cursor-pointer rounded-sm mr-1 text-sm font-bold py-1.5 h-8 text-center m-auto w-16" :class="[filter.junior?'clickButtonColor4':'normalButtonColor']" @click="clickUserBtn('junior')">
              部下
            </div>
            <div v-if="auth" class="cursor-pointer rounded-sm text-sm font-bold py-1.5 h-8 text-center m-auto w-16" :class="filter.all?'clickButtonColor4':'normalButtonColor'" @click="clickUserBtn('all')">
              全員
            </div>
          </div>

          <!-- ユーザー名 -->
          <!-- 管理者or賞与設定権限ありor上司 -->
          <div v-if="(auth||boss)" class="mr-2">
            <input
              type="search"
              placeholder="名前 検索"
              class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 text-sm"
              v-model="filter.user"
            />
          </div>

          <PrimaryButton
            text="検索"
            class="whitespace-nowrap w-20"
            @click="getData(1)"
            :disabled="loading"
            :buttonContents="'要'"
          >
            <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
          </PrimaryButton>
        </div>
      </template>
    </PageHeader>

    <main class="absolute w-screen bottom-4 mt-5" :class="isMobileDevice?'top-10':'top-24'">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">

        <div class="bg-white rounded-md border border-gray-200 h-full overflow-auto">
          <!-- 切替 スマホ用 -->
          <div v-if="isMobileDevice" class="rounded w-full border border-blue-300 bg-blue-50">
            <div class="flex items-center py-1 rounded mx-5 flex-wrap justify-around">
              <div v-for="t in tabList"
                :key="'tab' + t.id"
                class="w-28 text-center m-1 cursor-pointer"
                :class="[tabNo == t.id ? 'bg-light-blue-700' : 'hover:bg-gray-400', 'bg-gray-300 rounded-md py-1 text-xs font-medium text-white']"
                @click="changeTab(t.id)"
              >
                {{ t.name }}
              </div>
            </div>
          </div>

          <!-- 承認申請 -->
          <div v-if="tabNo==1" class="h-full">
            <div v-if="loading" class="animate-pulse font-bold w-fit m-auto">Loading...</div>
            <div v-if="list&&list.length">
              <!-- PC用 -->
              <table v-if="!isMobileDevice" class="text-sm w-full border rounded text-gray-700">
                <thead class="sticky top-0 z-20">
                  <tr class="text-gray-500 text-xs border border-gray-300 bg-colu font-bold">
                    <th v-for="(c, i) in columns1" :key="'c'+i" class="text-left p-2" :class="c.class">{{ c.val }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in list" :key="'pc'+i" class="hover-color border-b">
                    <!-- 参加日 -->
                    <td class="text-left px-2 py-3">
                      {{ row.day }}
                    </td>
                    <!-- タイトル -->
                    <td class="text-left px-2 py-3">
                      {{ row.title }}
                    </td>
                    <!-- 申請者 -->
                    <td class="text-left px-2 py-3">
                      <div class="font-bold">{{ row.userName }}</div>
                      <div class="text-xs mt-1">{{ row.requestDay }}</div>
                    </td>
                    <!-- 承認者1 -->
                    <td class="text-center px-2 py-3">
                      <Badge :color="statusColor[row.approval1]">{{ row.approval1 }}</Badge>
                      <div class="mt-1">{{ row.approverName1 }}</div>
                      <div class="text-xs mt-1">{{ row.approvalDay1 }}</div>
                    </td>
                    <!-- 承認者2 -->
                    <td class="text-center px-2 py-3">
                      <div v-if="row.approver2">
                        <Badge :color="statusColor[row.approval2]">{{ row.approval2 }}</Badge>
                        <div class="mt-1">{{ row.approverName2 }}</div>
                        <div class="text-xs mt-1">{{ row.approvalDay2 }}</div>
                      </div>
                    </td>
                    <!-- ステータス -->
                    <td class="text-left px-2 py-3 text-xs">
                      <div v-if="row.userId==loginUser.id">
                        <div v-if="row.status=='申請中'">申請中です</div>
                        <div v-else-if="row.status=='差戻'" class="text-red-700">差戻されました</div>
                      </div>
                      <div v-else class="text-red-700">
                        あなたの承認待ちです
                      </div>
                    </td>
                    <!-- ボタン -->
                    <td class="text-right px-2 py-1">
                      <div v-if="row.userId==loginUser.id" class="w-full">
                        <PrimaryButton
                          text="編集"
                          class="whitespace-nowrap bg-light-blue-100 text-blue-700 w-full"
                          @click="edit(row)"
                        >
                          <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                        </PrimaryButton>
                      </div>

                      <div v-else>
                        <PrimaryButton
                          text="確認"
                          class="whitespace-nowrap w-full"
                          @click="openModal(row)"
                        >
                          <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                        </PrimaryButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- スマホ用 -->
              <div v-else>
                <div v-for="(row, i) in list" :key="'sp'+i" class="border-b-2 border-gray-400 p-2 text-sm text-gray-700 ">
                  <div class="w-fit mx-auto">
                    <div class="text-xs text-gray-500 font-bold border-b w-fit">参加日</div>
                    <div class="ml-10 mb-2">{{ row.day }}</div>

                    <div class="text-xs text-gray-500 font-bold border-b w-fit max-w-">タイトル</div>
                    <div class="ml-10 mb-2 whitespace-pre-line">{{ row.title }}</div>

                    <div class="text-xs text-gray-500 font-bold border-b w-fit">申請者</div>
                    <div class="ml-10 mb-2 font-bold">{{ row.userName }}<span class="text-xs pl-5 font-normal">{{ row.requestDay }}</span></div>

                    <div class="text-xs text-gray-500 font-bold border-b w-fit">承認者1</div>
                    <div class="ml-10 mb-1">{{ row.approverName1 }}<Badge :color="statusColor[row.approval1]" class="ml-3">{{ row.approval1 }}</Badge></div>
                    <div class="ml-10 mb-2 text-xs">{{ row.approvalDay1 }}</div>

                    <div v-if="row.approver2" class="text-xs text-gray-500 font-bold border-b w-fit">承認者2</div>
                    <div v-if="row.approver2" class="ml-10 mb-1">{{ row.approverName2 }}<Badge :color="statusColor[row.approval2]" class="ml-3">{{ row.approval2 }}</Badge></div>
                    <div v-if="row.approver2" class="ml-10 mb-2 text-xs">{{ row.approvalDay2 }}</div>

                    <div class="text-center text-xs animate-pulse">
                      <div v-if="row.userId==loginUser.id">
                        <div v-if="row.status=='申請中'">申請中です</div>
                        <div v-else-if="row.status=='差戻'" class="text-red-700">差戻されました</div>
                      </div>
                      <div v-else class="text-red-700">
                        あなたの承認待ちです
                      </div>
                    </div>

                    <div class="p-2 mx-auto w-fit">
                      <PrimaryButton
                        v-if="row.userId==loginUser.id"
                        text="編集"
                        class="whitespace-nowrap bg-light-blue-100 text-blue-700"
                        @click="edit(row)"
                      ></PrimaryButton>
                      <PrimaryButton
                        v-else
                        text="確認"
                        class="whitespace-nowrap"
                        @click="openModal(row)"
                      ></PrimaryButton>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-else-if="!loading" class="flex justify-center items-center text-gray-400 w-full h-full">
              <EmptyMessage
                iconName="Document"
                message="現在、あなたの承認待ち・申請中・差戻の感想文はありません。"
              />
            </div>
          </div>

          <!-- 感想文 -->
          <div v-if="tabNo==2" class="p-2 w-full max-w-3xl mx-auto">
            <!-- 途中保存が複数ある場合 -->
            <div v-if="list&&list.length" class="text-center">
              <div class="text-blue-700 font-bold">作成途中の感想文が<span v-if="list.length>1">複数</span>あります。</div>

              <!-- 作成途中リスト -->
              <!-- PC用 -->
              <table v-if="!isMobileDevice" class="text-sm w-full border rounded">
                <thead class="sticky top-0 z-20">
                  <tr class="text-gray-500 text-xs border border-gray-300 bg-colu font-bold">
                    <th v-for="(c, i) in columns2" :key="'c'+i" class="text-left p-2" :class="c.class">{{ c.val }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in list" :key="'pc'+i" class="hover-color border-b">
                    <!-- 参加日 -->
                    <td class="text-left px-2 py-3">
                      {{ row.day }}
                    </td>
                    <!-- タイトル -->
                    <td class="text-left px-2 py-3">
                      {{ row.title }}
                    </td>
                    <!-- 編集 -->
                    <td class="text-right px-2 py-2">
                      <PrimaryButton
                        text="編集"
                        class="whitespace-nowrap mr-7"
                        @click="getReviewById(row.id)"
                      >
                        <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                      </PrimaryButton>
                      <PrimaryButton
                        text="削除"
                        class="whitespace-nowrap bg-red-700 px-1"
                        @click="deleteReview(row.id, i)"
                      >
                        <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                      </PrimaryButton>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- スマホ用 -->
              <div v-else>
                <div v-for="(row, i) in list" :key="'sp'+i" class="border-b-2 border-gray-400 p-2 text-sm text-gray-700 ">
                  <div class=" mx-auto">
                    <div class="text-xs text-gray-600 font-bold border-b w-fit px-2">参加日</div>
                    <div class="ml-10 mb-2">{{ row.day }}</div>

                    <div class="text-xs text-gray-600 font-bold border-b w-fit px-2">タイトル</div>
                    <div class="ml-10 mb-2 whitespace-pre-line">{{ row.title }}</div>

                    <div class="flex justify-between">
                      <div class=" text-red-700 font-bold text-xs border-b border-red-700 w-fit self-end mr-auto px-1" @click="deleteReview(row.id, i)">削除</div>
                      <PrimaryButton
                        text="編集"
                        class="whitespace-nowrap ml-10 mr-2"
                        @click="getReviewById(row.id)"
                      ></PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 感想文作成 -->
            <div v-else>
              <div v-if="tabNo==2" class="text-center my-3">
                <PrimaryButton text="作成中一覧 ・ 削除" class="making" @click="getMaking()"/>
              </div>
              <div v-if="review.status=='申請中'" class="animate-pulse font-bold w-fit mx-auto text-red-700 mb-5">ただいま申請中</div>
              <!-- 差戻理由 -->
              <div v-if="review.sendBack" class="text-gray-700 mb-5">
                <div class="font-bold mb-1 text-xs">差戻理由</div>
                <div class="text-sm p-2 rounded whitespace-pre border-2 border-gray-300 bg-yellow-50">{{ review.sendBack }}</div>
              </div>

              <!-- 1、行数選択 -->
              <div class="text-red-700 font-bold text-sm text-center">
                <p>指示された行数を選択してください</p>
                <p class="text-gray-600 pt-2">※アポロスクール⇒20行、見学等⇒「●行+取組み」など内容によって決まっています</p>
              </div>
              <div class="flex flex-wrap text-white text-xs justify-center mt-2">
                <div v-for="t in typeList"
                  :key="'rt' + t.id"
                  class="w-32 text-center m-1 cursor-pointer"
                  :class="[review.type == t.id ? 'bg-light-blue-700' : '', 'bg-gray-400 rounded-md py-1 text-sm font-medium text-white']"
                  @click="changeType(t)"
                >
                  {{ t.name }}
                </div>
              </div>

              <!-- 2、参加日 -->
              <div v-if="review.type" class="mt-3">
                <div class="text-sm text-blue-700 font-bold mb-2 text-center">＊自動保存します＊</div>
                <div class="text-xs text-gray-700 font-bold mb-1">参加日</div>
                <input
                  type="date"
                  class="border border-gray-300 rounded-md leading-5 focus:text-gray-900 w-full font-bold"
                  :disabled="review.status=='承認済み'"
                  v-model="review.day"
                  @change="changeReview('day', -1)"
                />
              </div>

              <!-- 内容 -->
              <div v-if="review.day&&review.id">
                <!-- タイトル -->
                <div class="text-xs text-gray-700 font-bold mt-3 mb-1">タイトル</div>
                <input
                  type="text"
                  placeholder="タイトルを記入してください"
                  class="border border-gray-300 rounded-md leading-5 focus:text-gray-900 w-full font-bold"
                  :disabled="review.status=='承認済み'"
                  v-model="review.title"
                  @change="changeReview('title', -1)"
                />

                <!-- 気づき -->
                <div class="text-sm text-blue-700 font-bold mt-5 mb-2">気づきを書いてください</div>
                <div v-for="(row, i) in review.note.slice(0, type.num)" :key="'rev'+i" class="mb-3 flex border-b-2 border-gray-300 ">
                  <div class="font-bold mr-2 self-end">{{ i + 1 }}.</div>
                  <textarea
                    rows="1"
                    class="border-0 w-full rounded auto-resize"
                    v-model="review.note[i]"
                    :disabled="review.status=='承認済み'||loading"
                    @change="changeReview('note', i)"
                    @input="resize($event)"
                  ></textarea>
                </div>

                <!-- 今後取り組む -->
                <div v-if="([2, 4]).includes(type.id)" class="mt-5">
                  <div class="text-sm text-blue-700 font-bold mb-2">◆ 今後取り組む内容</div>
                  <textarea
                    rows="1"
                    class="border-blue-400 w-full rounded auto-resize"
                    v-model="review.photo.note"
                    :disabled="review.status=='承認済み'||loading"
                    @change="changeReview('photoNote', i)"
                    @input="resize($event)"
                  ></textarea>

                  <!-- 写真 -->
                  <div class="text-sm text-blue-700 font-bold mt-3 mb-2">◆ 写真を1枚添付してください</div>
                  <div class="flex">
                    <!-- カメラ -->
                    <div class="file-btn rounded w-70px h-full mr-4">
                      <PrimaryButton :buttonContents="'要'" class="bg-teal-600 h-full w-70px">
                        <Icon v-if="!loading" slot="before" iconName="Camera" iconType="solid" :strokeWidth="2" class="text-white h-5 w-8" />
                        <LoadingIcon v-else slot="before" class="h-5 w-5 my-auto text-white" />
                      </PrimaryButton>
                      <input class="file-type w-70px" type="file" accept="image/*" capture="environment" @change="imageToBase64($event)" multiple />
                    </div>

                    <!-- フォルダ選択 -->
                    <div class="file-btn rounded w-70px h-full">
                      <PrimaryButton :buttonContents="'要'" class="bg-light-blue-600 h-full w-70px" :class="loading?'':'p-1'">
                        <Icon v-if="!loading" slot="before" iconName="FolderDownload" iconType="outline" :strokeWidth="2" class="text-white h-7 w-8 bg-light-blue-600" />
                        <LoadingIcon v-else slot="before" class="h-5 w-5 my-auto text-white " />
                      </PrimaryButton>
                      <input class="file-type w-70px" type="file" accept="image/*" @change="imageToBase64($event)" multiple />
                    </div>
                  </div>

                  <!-- 添付した写真 -->
                  <div v-if="review.photo.photo">
                    <a :href="review.photo.photo" :data-lightbox="1">
                      <img :src="review.photo.photo" class="w-full max-w-xs max-h-72 object-contain">
                    </a>
                  </div>
                </div>

                <!-- 申請 -->
                <div class="rounded p-2 border-double border border-yellow-300 my-5 bg-yellow-50">
                  <div class="font-bold text-yellow-600">
                    承認申請
                  </div>
                  <div class="text-gray-600 pl-3 text-sm">承認者を選択してください（最大2名）</div>

                  <div class="mt-5 mb-1 text-xs font-bold text-gray-600">承認者絞り込み</div>
                  <div class="font-bold text-gray-600 text-sm" :class="isMobileDevice?'':'flex'">
                    <div class="m-2">
                      <label class="py-1 px-3">
                        <input
                          type="radio"
                          :value="1"
                          v-model="apploverFilter"
                          @change="clickApploverFilter(1)"
                        />
                        自分の上司
                      </label>
                    </div>
                    <div class="m-2">
                      <label class="py-1 px-3">
                        <input
                          type="radio"
                          :value="2"
                          v-model="apploverFilter"
                          @change="clickApploverFilter(2)"
                        />
                        アポロスクール担当者
                      </label>
                    </div>
                    <div class="m-2">
                      <label class="py-1 px-3">
                        <input
                          type="radio"
                          :value="3"
                          v-model="apploverFilter"
                          @change="clickApploverFilter(3)"
                        />
                        全員
                      </label>
                    </div>
                  </div>

                  <div class="mt-5" :class="isMobileDevice?'':'flex'">
                    <!-- 1人目 -->
                    <div class="flex-1 m-1">
                      <WmsSuggestInput
                        name="ap1"
                        caption="1人目（必須）"
                        :selectionItems="appList"
                        displayField="name"
                        :clearable="true"
                        v-model="review.approverName1"
                        @selected="selectedApp(1, $event)"
                      />
                    </div>
                    <!-- 2人目 -->
                    <div class="flex-1 m-1">
                      <WmsSuggestInput
                        name="ap1"
                        caption="2人目（必要あれば選択してください）"
                        :selectionItems="appList"
                        displayField="name"
                        :clearable="true"
                        v-model="review.approverName2"
                        @selected="selectedApp(2, $event)"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="review.status=='申請中'" class="animate-pulse font-bold w-fit m-auto text-red-700 mt-5">ただいま申請中</div>

                <!-- 完了 -->
                <div class="mt-5 mb-3 mx-1">
                  <PrimaryButton
                    v-if="review.status!='承認済み'"
                    text="申請する"
                    class="whitespace-nowrap w-full mt-2"
                    :disabled="loading"
                    @click="save()"
                    :buttonContents="'要'"
                  >
                    <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                  </PrimaryButton>
                </div>
              </div>
              <div class="text-transparent text-xs">{{reload}}</div>
            </div>
          </div>

          <!-- 一覧 -->
          <div v-else-if="tabNo==3" class="h-full">
            <div class="overflow-auto list-height border-b">
              <!-- PC用 -->
              <table v-if="!isMobileDevice&&list.length" class="text-sm w-full text-gray-700">
                <thead class="th sticky top-0 z-20">
                  <tr class="text-gray-500 text-xs border border-gray-200 bg-colu font-bold">
                    <th v-if="auth||boss" class="text-left p-2">名前</th>
                    <th v-for="(c, i) in columns3" :key="'col'+i" class="text-left p-2" :class="c.class">{{ c.val }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in list" :key="i" class="hover-color border-b cursor-pointer" @click="openModal(row)">
                    <!-- 名前 -->
                    <td v-if="auth||boss" class="px-2 py-3 font-bold">
                      {{ row.userName }}
                    </td>
                    <!-- 参加日 -->
                    <td class="px-2 py-3">
                      {{ row.day }}
                    </td>
                    <!-- タイトル -->
                    <td class="px-2 py-3">
                      <p>{{ row.title }}</p>
                      <p class="text-xs text-gray-500">{{ row.item2 }}</p>
                    </td>
                    <!-- 今後の取り組み -->
                    <td class="px-2 py-3 whitespace-pre text-xs">
                      {{ row.note }}
                    </td>
                    <!-- 承認者 -->
                    <td class="px-2 py-3 whitespace-nowrap text-xs">
                      <p>{{ row.approverName1 }}</p>
                      <p v-if="row.approverName2" class="mt-1">{{ row.approverName2 }}</p>
                    </td>
                    <!-- ステータス -->
                    <td class="px-2 py-3 whitespace-nowrap text-center">
                      <Badge :color="statusColor[row.status]">{{ row.status }}</Badge>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- スマホ用 -->
              <div v-else-if="isMobileDevice">
                <div class="p-1">
                  <div class="text-sm">絞り込み
                    <span v-if="!boss&&!auth" class="text-blue-700 font-bold text-xs pl-5">※自分の分のみ表示</span>
                  </div>

                  <!-- 期間 -->
                  <div class="flex items-stretch mr-2">
                    <input type="date" v-model="filter.start" class="rounded border-gray-300 p-1 text-xs min-w-100px" />
                    <div class="w-fit font-bold mx-1 my-auto">～</div>
                    <input type="date" v-model="filter.end" class="rounded border-gray-300 p-1 text-xs min-w-100px" />
                    <div class="text-xs p-2 bg-green-100 text-green-800 border border-green-800 rounded cursor-pointer ml-auto font-bold" @click="deletePeriod()">
                      期間なし
                    </div>
                  </div>

                  <!-- 部下全員 切り替え -->
                  <div v-if="(auth||boss)" class="flex mt-2">
                    <div class="mx-1 cursor-pointer rounded-sm text-sm font-bold py-1.5 h-8 text-center m-auto w-16" :class="[filter.junior?'clickButtonColor4':'normalButtonColor']" @click="clickUserBtn('junior')">
                      部下
                    </div>
                    <div v-if="auth" class="mx-1 cursor-pointer rounded-sm text-sm font-bold py-1.5 h-8 text-center m-auto w-16" :class="filter.all?'clickButtonColor4':'normalButtonColor'" @click="clickUserBtn('all')">
                      全員
                    </div>

                    <!-- ユーザー名 -->
                    <!-- 管理者or賞与設定権限ありor上司 -->
                    <div v-if="(auth||boss)" class="ml-4 mr-2">
                      <input
                        type="search"
                        placeholder="名前 検索"
                        class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 text-sm"
                        v-model="filter.user"
                      />
                    </div>
                  </div>

                  <div class="mt-2 flex justify-between">
                    <div class="text-red-700 text-xs font-bold self-center">行をタップで詳細確認可能</div>
                    <PrimaryButton
                      text="検索"
                      class="whitespace-nowrap w-20 mr-2"
                      @click="getData(1)"
                      :disabled="loading"
                      :buttonContents="'要'"
                    >
                      <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
                    </PrimaryButton>
                  </div>
                </div>
                <table v-if="list.length" class="text-sm w-full text-gray-700">
                  <thead class="th sticky top-0 z-20">
                    <tr class="text-gray-600 text-xs border border-gray-200 bg-colu">
                      <th class="text-left py-1 px-2 font-normal">
                        <div v-if="auth||boss">名前</div>
                        <div>参加日</div>
                        <div>タイトル</div>
                        <div>今後の取り組み</div>
                      </th>
                      <th class="text-left p-2 font-normal">
                        <div>承認者</div>
                        <div>ステータス</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in list" :key="i" class="hover-color border-b cursor-pointer" @click="openModal(row)">
                      <td class="px-2 py-3">
                        <p v-if="auth||boss" class="font-bold">{{ row.userName }}</p>
                        <p class="text-xs">{{ row.day }}</p>
                        <p class="text-blue-700 mt-1">{{ row.title }}</p>
                        <p class="text-xs text-gray-500">{{ row.item2 }}</p>
                        <p v-if="row.note" class="whitespace-pre text-xs border border-gray-300 rounded p-1">{{ row.note }}</p>
                      </td>
                      <!-- 承認者 -->
                      <td class="px-2 py-3 whitespace-nowrap text-xs">
                        <p>{{ row.approverName1 }}</p>
                        <p v-if="row.approverName2" class="mt-1">{{ row.approverName2 }}</p>
                        <Badge :color="statusColor[row.status]" class="mt-2">{{ row.status }}</Badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="!loading && !list.length" class="flex justify-center items-center text-gray-400 w-full h-full">
                <EmptyMessage
                  iconName="Document"
                  message="該当するデータはありません。"
                />
              </div>
            </div>
            <div v-if="!loading" class="w-fit mx-auto mt-2">
              <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 感想文モーダル -->
    <ReviewModal
      v-model="reviewModalOpen"
      :open="reviewModalOpen"
      :target="modalData"
      @getData="getData()"
      @closed="reviewModalOpen=false"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Badge from '@components/Badge.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import Pagination from 'vue-pagination-2'
import ReviewModal from '../components/ReviewModal.vue'
import * as chatwork from '@libs/chatwork'
import * as image from '@libs/image'
import * as utils from '@libs/utils'
import * as moment from 'moment'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'

import PageModel from '../../main/pages/PageModel.vue'

const settionStrageName = 'stampTableStrage'
const settionStrageApp = 'appUserList'

// アポロスクール担当者
const APOLLO_SCHOOL = '6230'

// 最大行数
const max = 30

// 感想文
const ROW = {
    id: null,
    userId: null,
    userName: '',
    type: null,
    title: '',
    status: null,
    point: null,
    // 30個の配列
    note: Array.from({ length: max }, () => ''),
    photo: { note: '', photo: '' },
    approverName1: null,
    approverName2: null,
    sendBack: null
}

// 行数
const TYPE_LIST = [
  { id: 1, name: '20行', num: 20, isAdd: false },
  { id: 2, name: '20行＋取組み', num: 20, isAdd: true },
  { id: 3, name: '30行', num: 30, isAdd: false },
  { id: 4, name: '30行＋取組み', num: 30, isAdd: true },
]

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    EmptyMessage,
    WmsSuggestInput,
    PrimaryButton,
    LoadingIcon,
    Pagination,
    // TrashIcon,
    // MenuIcon,
    // draggable,
    Badge,
    // DateSelect
    ReviewModal
  },

  data() {
    return {
      loading: false,
      // タブ種類
      tabList: [
        { id: 2, name: '気づき感想文入力' },
        { id: 1, name: '承認申請中・差戻' },
        { id: 3, name: '一覧' }
      ],
      // 選択したタブ
      tabNo: 2,
      // 感想文種別
      typeList: utils.clone(TYPE_LIST),
      // 選択した感想文種別
      type: { id: null, name: '', num: null, isAdd: false },
      // 感想文
      review: utils.clone(ROW),
      // 感想文途中保存失敗データ
      failedData: {},
      // 表示するデータ
      list: [],
      // 本日日付
      today: moment().format('YYYY-MM-DD'),
      // 検索条件
      filter: {
        start: null,
        end: null,
        junior: false,
        all: false,
        user: null,
      },
      // 申請中カラム
      columns1: [
        { val: '参加日' },
        { val: 'タイトル' },
        { val: '申請者' },
        { val: '承認者1', class: 'text-center' },
        { val: '承認者2', class: 'text-center' },
        { val: 'ステータス' },
        { val: '' },
      ],
      // 作成中選択カラム
      columns2: [
        { val: '参加日' },
        { val: 'タイトル' },
        { val: '' },
      ],
      // 一覧カラム
      columns3: [
        { val: '参加日' },
        { val: 'タイトル' },
        { val: '今後の取り組み' },
        { val: '承認者' },
        { val: 'ステータス', class: 'text-center' },
      ],
      // 承認者絞り込み
      apploverFilter: 1,
      // 承認者リスト（画面表示）
      appList: [],
      // 承認者リスト（全員）
      appListAll: [],

      // 感想文モーダル
      reviewModalOpen: false,
      modalData: {},

      // ステータスカラー
      statusColor: {
        '承認待ち': 'pink',
        '申請中': 'pink',
        '承認済み': 'lightGreen',
        '差戻': 'red',
        '作成中': 'orange'
      },

      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 50,
      // 全件数
      records: 0,

      reload: 0
    }
  },

  computed: {
		loginUser() {
			return this.$store.getters.user
		},

    boss() {
      return this.$store.getters.loginUserData.boss
    },

    auth() {
      return this.$store.getters.auth.adminAuth || this.$store.getters.auth.bonusAuth
    },

    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile && !utils.deviceInfo.isTablet
    },

    /**
     * タブレット・スマホ
     */
    isTablet() {
      return utils.deviceInfo.isMobile || utils.deviceInfo.isTablet
    },

    /**
     * safari
     */
    isSafari() {
      return utils.deviceInfo.isSafari
    },
  },

  async created() {
    this.getSettionStrage()
    // 承認者URLの場合
    if (this.$route.query.app == 1) {
      this.tabNo = 1
    }
    await this.getData()
    await this.getAppList()
  },

  methods: {
    /**
     * リフレッシュボタン
     */
    async refresh() {
      this.review = utils.clone(ROW)
      await this.getData()
    },

    /**
     * セッションストレージ取得
     */
    getSettionStrage() {
      const searchJson = sessionStorage.getItem(settionStrageName)
      const getItem = JSON.parse(searchJson)
      if (getItem) {
        if (getItem.tabNo) {
          this.tabNo = getItem.tabNo
        }
        delete getItem.tabNo
        this.filter = getItem
      }
    },

    /**
     * データ取得
     */
    async getData(num) {
      this.loading = true
      this.list = []
      this.records = 0
      if (num) {
        this.page = num
      }
      // 承認申請中リスト
      if (this.tabNo == 1) {
        const res = await backend.searchData('evaluation/getReviewByApproval', { userId: this.loginUser.id })
        if (res.data.data) {
          this.list = res.data.data
        }
      // 感想文
      } else if (this.tabNo == 2) {
        this.review = utils.clone(ROW)
        const res = await backend.searchData('evaluation/getStampReview', { userId: this.loginUser.id })
        // 作成中の感想文がある
        if (res.data.data) {
          const r = res.data.data
          // 作成中が1件
          if (r.review) {
            this.setReviewNote(r)

          // 途中保存が複数
          } else if (r.editRowsLength) {
            this.list = r.list
          }
        }
      // 一覧
      } else if (this.tabNo == 3) {
        const res = await backend.postData('evaluation/getStampList', { userId: this.loginUser.id, ...this.filter, auth: this.auth, boss: this.boss, page: this.page, perPage: this.perPage })
        if (res.data.data && res.data.data.length) {
          this.list = res.data.data
          this.records = Number(this.list[0].records)
        }
      }
      this.setSessionStorage()
      this.loading = false
    },

    async getMaking() {
      this.loading = true
      this.list = []
      const res = await backend.searchData('evaluation/getStampReview', { userId: this.loginUser.id })
      // 作成中の感想文がある
      if (res.data.data) {
        const r = res.data.data
        this.review = utils.clone(ROW)
        // 複数あり
        if (r.editRowsLength) {
          this.list = r.list
        // 1件のみ
        } else {
          this.list = [r.review]
        }
      }

      if (!this.list.length) {
        await dialogs.showInfoDialog('データなし', '現在作成中はありません')
      }
      this.loading = false
    },

    /**
     * 承認者リスト取得
     */
    async getAppList() {
      const searchJson = sessionStorage.getItem(settionStrageApp)
      const getItem = JSON.parse(searchJson)
      if (getItem && getItem.length) {
        this.appListAll = getItem
      } else {
        const res = await backend.searchData('user/getByIsBoss', { userId: this.loginUser.id })
        if (res.data.data) {
          this.appListAll = res.data.data
          const searchStr = JSON.stringify(this.appListAll)
          sessionStorage.setItem(settionStrageApp, searchStr)
        }
      }
      this.appList = utils.clone(this.appListAll)
      this.clickApploverFilter(this.apploverFilter)
    },

    /**
     * 承認者絞り込み
     * @param val 絞り込み種別
     */
    clickApploverFilter(val) {
      if (val == 1) {
        this.appList = this.appListAll.filter((a) => {
          return a.boss
        })
      } else if (val == 2) {
        const res = this.appListAll.find((a) => {
          return a.userId == APOLLO_SCHOOL
        })
        if (res) {
          this.appList = [res]
        }
      } else {
        this.appList = utils.clone(this.appListAll)
      }
    },

    /**
     * 承認者選択
     * @param num 1人目or2人目
     * @param e 選択内容
     */
    selectedApp(num, e) {
      const key = 'approver' + num
      this.review[key] = e.userId
    },

    /**
     * 感想の行を設定
     */
    setReviewNote(r) {
      const res = r.review

      res.note = Array.from({ length: max }, () => '')
      const note = r.note

      note.forEach(n => {
        res.note[n.num - 1] = n.note
      })

      // 行数
      const t = this.typeList.find((type) =>{
        return type.id == res.type
      })
      if (t) {
        this.type = t
      }

      // 写真がある場合
      if (res.photo.photo) {
        // imgタグで表示できる形に変換
        res.photo.photo = image.bufferToDataUrl(res.photo.photo)
      }
      this.review = res
      this.resizeAll()
    },

    /**
     * 新規
     */
    setNewReview() {
      this.list = []
      this.review = utils.clone(ROW)
    },

    /**
     * 感想文IDで取得
     * @param id 感想文ID
     */
    async getReviewById(id) {
      this.loading = true
      this.list = []
      this.review = utils.clone(ROW)
      const res = await backend.searchData('evaluation/getReviewById', { id })
      // 作成中の感想文がある
      if (res.data.data) {
        const r = res.data.data
        this.setReviewNote(r)
      }
      this.list = []
      this.loading = false
    },

    /**
     * 感想文IDで削除
     * @param id 感想文ID
     * @param i 対象インデックス
     */
    async deleteReview(id, i) {
      const log = await dialogs.showWarningConfirmDialog('削除しますか？', '本当に削除してよろしいでしょうか？')
      if (log != 'YES') {
        return
      }
      this.loading = true
      await backend.deleteData('evaluation/deleteReview', { id })
      this.list.splice(i, 1)
      this.loading = false
    },

    /**
     * タブ変更
     */
    changeTab(id) {
      this.loading = true
      this.list = []
      this.tabNo = id
      this.getData()
    },

    /**
     * 行数変更
     */
    changeType(type) {
      this.review.type = type.id
      this.type = type

      if (this.review.id) {
        this.changeReview('type', -1)
      }
    },

    /**
     * 期間削除
     */
    deletePeriod() {
      this.filter.start = null
      this.filter.end = null
    },

    /**
     * ユーザー表示切替
     */
    clickUserBtn(val) {
      if (this.filter[val]) {
        this.filter[val] = false
      } else {
        this.filter[val] = true
        if (val == 'junior') {
          this.filter.all = false
        } else {
          this.filter.junior = false
        }
      }
      this.getData(1)
    },

    /**
     * 感想文途中保存
     * @param i index
     */
    async changeReview(key, i) {
      // 自分の感想文ではない場合は保存しない(念のため)
      if (this.review.userId && this.loginUser.id != this.review.userId) {
        return
      }

      if (!this.review.status || this.review.status !== '申請中') {
        this.review.status = '作成中'
      }
      let num = null
      this.reload = true
      const id = this.review.id
      let value = this.review[key]

      // 本文の保存
      if (key == 'note') {
        num = i + 1
        value = this.review.note[i]

      // 今後の取り組み
      } else if (key == 'photoNote') {
        value = this.review.photo.note
      }
      let saveData = {
        id,
        userId: this.loginUser.id,
        num,
        key,
        value
      }

      // 新規保存の場合
      if (!id) {
        saveData = {
          ...this.review,
          userId: this.loginUser.id,
          key
        }
      }

      let failed = false

      try {
        const res = await backend.postData('evaluation/changeReview', saveData)
        if (!this.review.id && res.data.data && res.data.data.id) {
          this.review.id = res.data.data.id
        }
        // 前回失敗していたら、失敗分を保存
        if (this.failedData && this.failedData.key) {
          failed = true
          await backend.postData('evaluation/changeReview', this.failedData)
        }
        this.failedData = {}
      } catch (error) {
        if (!failed) {
          // 失敗した内容
          this.failedData = { id: this.review.id, userId: this.loginUser.id, num, key, i, value }
        }
      }
      this.loading = false
    },

    /**
     * 写真添付
     */
    async imageToBase64 (event) {
      this.loading = true
      // 選択されたファイルの取得
      const file = event.target.files
      // Base64に変換する
      for (let j = 0; j < file.length; j++) {
        const reader = new FileReader()
        const f = file[j]

        reader.readAsDataURL(f)
        // 変換
        const compressedImage = await new Promise((resolve) => {
          reader.onload = () => {
            const img = new Image();
            img.src = reader.result;

            img.onload = () => {
              const compressedDataUrl = image.compressImage(img, true, 854, 0.8)
              resolve(compressedDataUrl)
            }
          }
        })
        // 即時保存＆保存した写真を返却
        this.review.photo.photo = await this.savePhoto(compressedImage)
      }
      this.loading = false
    },

    /**
     * 即時保存＆保存した写真を返却
     * @param base64 写真のbase64
     */
    async savePhoto(base64) {
      try {
        const save = {
          id: this.review.id,
          userId: this.loginUser.id,
          photo: 'review/' + this.review.id,
          base64
        }
        const savedPhoto = await backend.postData('evaluation/saveReviewPhoto', save)
        // imgタグで表示できる形に変換
        return image.bufferToDataUrl(savedPhoto.data.data)
      } catch (error) {
        return null
      }
    },

    /**
     * 保存ボタン
     */
    async save() {
      let saveData = {}

      // 感想文完了
      if (this.tabNo == 2) {
        if (this.review.status == '申請中') {
          const log = await dialogs.showWarningConfirmDialog('申請中ですが再申請しますか？', 'すでに申請中です。再度、申請してよろしいですか？')
          if (log != 'YES') {
            return
          }
        }
        this.reload = true
        await utils.wait(500)
        if (!this.review.title) {
          await dialogs.showErrorDialog('タイトル未入力', 'タイトルを入力してください。')
          this.reload = false
          return
        }
        for (let i = 0; i < this.type.num; i++) {
          if (!this.review.note[i] || !this.review.note[i].trim()) {
            await dialogs.showErrorDialog(`${i + 1}行目 未入力`, `${i + 1}行目を入力してください。`)
            this.reload = false
            return
          }
        }
        if (this.type.isAdd) {
          if (!this.review.photo.note || !this.review.photo.note.trim()) {
            await dialogs.showErrorDialog(`取り組む内容 未入力`, `「今後取り組む内容」を入力してください。`)
            this.reload = false
            return
          }
          if (!this.review.photo.photo) {
            await dialogs.showErrorDialog(`写真 未添付`, `写真を添付してください。`)
            this.reload = false
            return
          }
        }

        // 承認者1人目情報取得
        const app1 = this.checkApp(this.review.approverName1, this.review.approver1)
        if (!app1) {
          this.review.approverName1 = ''
          await dialogs.showErrorDialog(`承認者 1人目 未選択`, `承認者を選択してください。`)
          this.reload = false
          return
        }
        this.review.approver1 = app1.userId

        // 承認者2人目情報取得
        const app2 = this.checkApp(this.review.approverName2, this.review.approver2)
        if (app2) {
          this.review.approver2 = app2.userId
        } else {
          this.review.approver2 = null
          this.review.approverName2 = ''
        }

        if (app1.userId == this.loginUser.id) {
          await dialogs.showErrorDialog(`あなたは承認者にはなれません`, `承認者は自分以外の人にしてください。`)
          this.reload = false
          return
        }

        if (app2 && app2.userId == this.loginUser.id) {
          await dialogs.showErrorDialog(`あなたは承認者にはなれません`, `承認者は自分以外の人にしてください。`)
          this.reload = false
          return
        }

        if (app2 && app1.userId == app2.userId) {
          await dialogs.showErrorDialog(`承認者1・2が同じ人`, `どちらかの承認者を変更してください。`)
          this.reload = false
          return
        }

        // 対象の行数にする
        this.review.note = this.review.note.slice(0, this.type.num)
        // 取組みがない場合
        if (!this.type.isAdd) {
          this.review.photo = { note: '', photo: '' }
        }

        saveData = this.review
        saveData.userId = this.loginUser.id
        try {
          await backend.postData('evaluation/saveStampReview', saveData)
          this.review.status = '申請中'
          // チャット送信
          await this.sendChatWork(app1)
        } catch (error) {
          this.review.status = null
          alert('保存に失敗しました。申し訳ございませんが再度保存ボタンを押してください。')
        }
        this.reload = false
      }
    },

    /**
     * 選択した承認者名とユーザーIDが正しいか確認、チャット情報取得
     * @param name 承認者名
     * @param id 承認者ID
     */
    checkApp(name, id) {
      if (name) {
        if (id) {
          const user = this.appListAll.find((a) => {
            return a.userId == id
          })
          if (user && user.name && name == user.name) {
            return user
          }
        }

        // 名前からユーザーID取得
        name = utils.deleteSpace(name)
        const user2 = this.appListAll.find((a) => {
          return utils.deleteSpace(a.name) == name
        })
        if (user2 && user2.name) {
          return user2
        }
      }
      return null
    },

    /**
     * チャット送信
     */
    async sendChatWork(app) {
      if (!app.apiToken && !app.roomId) {
        await dialogs.showInfoDialog('保存完了・承認者チャット送信不可', 'Chatwork情報が取得できませんでしたので送信しておりませんが、感想文は保存・承認申請中です。')
        this.tabNo = 1
        this.getData()
        return
      }
      const message = []
      message.push(`[To:${app.accountId}] (承認者1) ${app.name}さん`)
      message.push(`[info][title]気づき感想文の承認をお願いします[/title]申請者：${this.loginUser.user_name}`)
      message.push(`参加日：${this.review.day}`)
      message.push(`タイトル：${this.review.title}`)
      message.push('')
      message.push(`●感想文申請一覧：${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}StampTable?app=1[/info]`)

      try {
        await chatwork.sendChatWorkMssage(
          app.roomId,
          message.join('\r\n'),
          app.apiToken
        )

        await dialogs.showSuccessDialog('保存完了・チャット送信完了', '保存しました。また、1人目の承認者へチャット送信しました。\r\n申請中一覧に遷移します。')
      } catch (error) {
        await dialogs.showErrorDialog('チャット送信失敗', '承認者へチャット送信できませんでしたが、感想文は保存し承認申請中です。\r\n申請中一覧に遷移します。')
      }
      this.tabNo = 1
      this.getData()
    },

    /**
     * セッションストレージ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify({ ...this.filter, tabNo: this.tabNo })
      sessionStorage.setItem(settionStrageName, searchStr)
    },

    /**
     * 編集ボタン
     * @param row 対象行
     */
    edit(row) {
      this.tabNo = 2
      this.getReviewById(row.id)
    },

    /**
     * 感想文モーダルopen
     * @param row 対象行
     */
    async openModal(row) {
      if (row.id.indexOf('-') > -1 || (row.item2 && row.item2.indexOf('サイボウズ') > -1)) {
        await dialogs.showInfoDialog('サイボウズは表示不可', 'サイボウズの詳細は表示できません。')
        return
      }
      this.modalData = row
      this.reviewModalOpen = true
    },

    /**
     * textareaの高さを自動で変更
     * safari用
     */
    resize(e) {
      if (!this.isSafari) {
        return
      }
      const ta = e.target

      // 一旦リセット
      ta.style.height = 'auto'

      // 空のときは1行に固定（Safari対策）
      if (!ta.value) {
        ta.style.height = '1.5em'
        return
      }

      // 入力があるときだけ scrollHeight を使う
      ta.style.height = ta.scrollHeight + 'px'
    },

    /**
     * すべての行の高さを取得
     */
    resizeAll() {
      if (!this.isSafari) {
        return
      }
      this.$nextTick(() => {
        this.$el
          .querySelectorAll('.auto-resize')
          .forEach(ta => this.resize({ target: ta }))
      })
    }
  },
}
</script>
<style scoped>
/* .main {
  min-width: 900px;
}

main {
  min-width: 930px;
} */

.list-height {
  height: calc(100vh - 202px);
}

textarea {
  field-sizing: content;
}

.bg-colu {
  background: #ebf0fb;
}

.hover-color:hover {
  background: rgba(184, 244, 242, 0.67);
}

.new {
  background: #eb84c2;
}

.making {
  background: #3c9661;
}

.making:hover {
  background: #26814c;
}

.file-btn {
  display: inline-block;
  position: relative;
}

_::-webkit-full-page-media,
_:future,
:root .file-btn {
  display: inline-block;
  position: relative;
}

.file-type {
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
}

_::-webkit-full-page-media,
_:future,
:root .file-type {
  height: 100%;
  top: 0;
  left: 0;
  width: 70px;
  opacity: 0;
  position: absolute;
}

 /* ページネーション */
#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}

</style>